<template lang="pug">
    Page.digital
        .digital__top(
            slot="header"
        )
            h1.digital__title
                | Город

            SvMenu(
                @remove="remove"
                @copy="copy"
            )

        SvTabs.digital__table(
            v-model="current"
            :tabs="['Общее']"
        )
            .digital__actions
                SvButton.residential-edit__action(
                    view="secondary"
                    text="Отмена"
                    :prependIcon=`{
                        icon: 'cancel',
                        width: 24,
                        height: 24,
                        hover: '#1993EB',
                        default: '#B7BAC6'
                    }`
                    @click="resetForm"
                )

                SvButton.residential-edit__action(
                    view="secondary"
                    text="Применить"
                    :prependIcon=`{
                        icon: 'refresh',
                        width: 24,
                        height: 24,
                        hover: '#1993EB',
                        default: '#B7BAC6'
                    }`
                    @click="save(false)"
                )

                SvButton.residential-edit__action(
                    view="primary"
                    text="Сохранить"
                    :prependIcon=`{
                        icon: 'check',
                        width: 24,
                        height: 24,
                        default: '#1993EB',
                        hover: '#1993EB'
                    }`
                    @click="save(true)"
                )

        keep-alive
            FormCity(
                v-if="current === 0"
            )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import {http} from '@/helpers/http';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import FormCity from '@/components/forms/FormCity.vue';

export default {
    name: "CityEdit",

    components: {
        Page,
        SvInput,
        SvButton,
        SvTable,
        SvMenu,
        SvTabs,
        FormCity,
    },

    beforeMount() {
        this.$store.dispatch('city/getById', this.$route.params.id);
    },

    beforeRouteUpdate(to, from, next) {
        if (to.params.id !== 'new') {
            this.$store.dispatch('city/getById', to.params.id);
        }
        next();
    },

    data() {
        return {
            current: 0,
        };
    },

    methods: {
        ...mapMutations({
            setValue: 'city/setValue',
            clearCurrent: 'city/clearCurrent',
        }),

        resetForm() {
            this.clearCurrent();
            this.$router.push({ name: 'city-edit' });
        },

        copy() {
            this.$store.commit('city/setCurrent', this.$route.params.id);
            this.setValue({ id: null });
            this.$router.push({
                name: 'city-edit',
                params: {
                    id: 'new',
                },
            });
        },

        async remove() {
            await this.$store.dispatch('city/remove', this.$route.params.id);
            this.$router.push({ name: 'city-edit' });
        },

        async save(isRedirect = false) {
            const id = await this.$store.dispatch('city/save');
            if (!isRedirect) {
                this.$router.push({
                    name: 'city-edit',
                    params: {
                        id,
                    },
                }).catch(err => {});
            } else {
                this.$router.push({ name: 'city-edit' });
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.digital__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.digital__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital__actions {
    display: flex;
    align-items: center;
    height: 100%;
}
</style>
